export class MarketDepthModel {
setValue(res){
if(res){
}
}
}